import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  fullWidth?: boolean;
  href?: string;
}
const CHECKOUT_URL = 'https://vitaliavida.com/cart/52522750345503:1';
export function Button({
  children,
  onClick,
  className = '',
  fullWidth = false,
  href = CHECKOUT_URL
}: ButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    window.location.href = href;
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        bg-coral text-white font-bold py-4 px-8 rounded-full shadow-lg 
        hover:bg-coral-600 hover:shadow-xl transition-colors duration-300
        flex items-center justify-center gap-3 text-lg md:text-xl
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-13">
      {children}
      <ArrowRight className="w-5 h-5 md:w-6 md:h-6" data-id="element-14" />
    </motion.button>;
}